import { useAuthContext } from './context';
import { getBaseUrl } from './utils';

const Logout = () => {
  const { logout, activeClient } = useAuthContext();

  if (!activeClient) {
    location.replace(getBaseUrl());
  } else {
    logout();
  }

  return null;
};

export { Logout };
